import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";

import About from "./pages/About";
import MyDashboard from "./pages/MyDashboard";
import Career from "./pages/Career";
import Features from "./pages/Features";
import Contact from "./pages/Contact";
import PricingPlan from "./pages/PricingPlan";
import Clients from "./pages/Client";
import Gallery from "./pages/Gallery";
import Privacy from "./pages/Privacy";
import SecurityPolicy from "./pages/SecurityPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import ProspectingSearch from "./pages/ProspectingSearch";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgetPassword from "./pages/ForgetPassword";
import CompanySearch from "./pages/CompanySearch";
import ExecutiveSearch from "./pages/ExecutiveSearch";
import LeadSearch from "./pages/LeadSearch";
import ExecutiveDetails from "./pages/ExecutiveDetails";
import ProductComparison from "./pages/ProductComparison";
import CompanySummary from "./pages/CompanySummary";
import OurData from "./pages/OurData";
import DirectDials from "./pages/DirectDials";
import LeadsManagement from "./pages/LeadsManagement";
import Integrations from "./pages/Integrations";
import B2BData from "./pages/B2BData";
import Faq from "./pages/Faq";
import Leads from "./pages/Leads";
import LeadDetails from "./pages/LeadDetails";
import MoreMenuContent from "./pages/MoreMenuContent";
import LeadsTimeline from "./pages/LeadsTimeline";
import ResetPassword from "./pages/ResetPassword";
import Sales from "./pages/Sales";
import Marketing from "./pages/Marketing";
import Hiring from "./pages/Hiring";
import ListBuilding from "./pages/List";
import DataEnrich from "./pages/DataEnrich";
import Linkedin from "./pages/Linkedin";
import Hospitality from "./pages/Hospitality";
import KeyFeatures from "./pages/KeyFeatures";
import Finance from "./pages/Finance";
import Technology from "./pages/Technology";
import { AuthProvider } from "./context/AuthContext";
import { AlertProvider } from "./context/AlertProvider";
import Review from "./pages/Review";
import Channel from "./pages/Channel";
import Web2Lead from "./pages/Web2Lead";
import CreateLeadForm from "./pages/CreateLeadForm";
import Seo from "./pages/Seo";
import Demo from "./pages/Demo";
import WhatWeOffer from "./pages/whatWeOffer";
import Meta from "./pages/Meta";
import EmailSetup from "./pages/EmailSetup";
import AuthCallback from "./pages/AuthCallback";
import { EmailProvider } from "./context/EmailContext";
import metaInfo from "./components/meta/metaInfo";
import Settings from "./components/reputation-manager/settings/Settings";
import Reviews from "./components/reputation-manager/review/Reviews";
import AuthenticatedLayout from "./layout/AuthenticatedLayout";
import ConditionalLayout from "./layout/ConditionalLayout";
import MeetingPublicLayout from "./layout/MeetingPublicLayout";
import UserManagement from "./pages/UserManagement";
import ChangePassword from "./pages/ChangePassword";
import RouteGuard from "./pages/RouteGuard";
import MyAccount from "./pages/MyAccount";
import Checkout from "./pages/Checkout";
import SubscriptionExpired from "./pages/SubscriptionExpired";
import LeadImport from "./pages/LeadImport";
import PricingPlans from "./pages/PricingPlans";
import LeadCustomFields from "./pages/LeadCustomFields";
import Layout from "./layout/Layout";
import LeadCalendar from "./components/calendar";
import AvailabilityFeature from "./components/availability";
import ScheduleMeeting from "./components/availability/ScheduleMeeting";
import CancelMeeting from "./components/availability/CancelMeeting";
import GenAIWidget from "./pages/GenAIWidget";
import WhatsApp from "./pages/WhatsApp";
import SettingsPage from "./pages/SettingsPage";
import WhatsAppAudience from "./pages/WhatsAppAudience";
import MailMergeListing from "./pages/MailMergeListing";
import MailMergeDetails from "./pages/MailMergeDetails";
// import TodayWorkspace from "./pages/TodayWorkspace";
// import MyWorkspace from "./pages/MyWorkspace";
// import CohortLeadsPage from "./pages/CohortLeadsPage";

const AppRoutes = (props) => {
  return (
    <HelmetProvider>
      <Router basename="" {...props}>
        <AlertProvider>
          <AuthProvider>
            <EmailProvider>
              <RouteGuard>
                <Routes path="/" {...props}>
                  <Route
                    index
                    element={
                      <>
                        <Meta
                          title={metaInfo.home.title}
                          description={metaInfo.home.description}
                          keywords={metaInfo.home.keywords}
                        />
                        <Home />
                      </>
                    }
                  />
                  <Route
                    path="/signin"
                    element={
                      <>
                        <Meta
                          title={metaInfo.signIn.title}
                          description={metaInfo.signIn.description}
                          keywords={metaInfo.signIn.keywords}
                        />
                        <Login />
                      </>
                    }
                  />
                  <Route
                    path="/signup"
                    element={
                      <>
                        <Meta
                          title={metaInfo.signUp.title}
                          description={metaInfo.signUp.description}
                          keywords={metaInfo.signUp.keywords}
                        />
                        <Signup />
                      </>
                    }
                  />
                  <Route
                    path="/forgetpassword"
                    element={
                      <>
                        <Meta
                          title={metaInfo.forgotPassword.title}
                          description={metaInfo.forgotPassword.description}
                          keywords={metaInfo.forgotPassword.keywords}
                        />
                        <ForgetPassword />
                      </>
                    }
                  />
                  <Route
                    path="/about-us"
                    element={
                      <>
                        <Meta
                          title={metaInfo.about.title}
                          description={metaInfo.about.description}
                          keywords={metaInfo.about.keywords}
                        />
                        <About />
                      </>
                    }
                  />
                  <Route
                    path="/dashboard-view"
                    element={
                      <>
                        <Meta
                          title={metaInfo.dashboardView.title}
                          description={metaInfo.dashboardView.description}
                          keywords={metaInfo.dashboardView.keywords}
                        />
                        <AuthenticatedLayout>
                          <MyDashboard />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  <Route
                    path="/career"
                    element={
                      <>
                        <Meta
                          title={metaInfo.career.title}
                          description={metaInfo.career.description}
                          keywords={metaInfo.career.keywords}
                        />
                        <Career />
                      </>
                    }
                  />
                  <Route
                    path="/features"
                    element={
                      <>
                        <Meta
                          title={metaInfo.features.title}
                          description={metaInfo.features.description}
                          keywords={metaInfo.features.keywords}
                        />
                        <Features />
                      </>
                    }
                  />
                  <Route
                    path="/contact-us"
                    element={
                      <>
                        <Meta
                          title={metaInfo.contactUs.title}
                          description={metaInfo.contactUs.description}
                          keywords={metaInfo.contactUs.keywords}
                        />
                        <Contact />
                      </>
                    }
                  />
                  <Route
                    path="/pricing"
                    element={
                      <>
                        <Meta
                          title={metaInfo.pricing.title}
                          description={metaInfo.pricing.description}
                          keywords={metaInfo.pricing.keywords}
                        />
                        <Layout>
                          <PricingPlans />
                        </Layout>
                      </>
                    }
                  />
                  <Route
                    path="/pricing-details"
                    element={
                      <>
                        <Meta
                          title={metaInfo.pricing.title}
                          description={metaInfo.pricing.description}
                          keywords={metaInfo.pricing.keywords}
                        />
                        <PricingPlan />
                      </>
                    }
                  />
                  <Route
                    path="/clients"
                    element={
                      <>
                        <Meta
                          title={metaInfo.clients.title}
                          description={metaInfo.clients.description}
                          keywords={metaInfo.clients.keywords}
                        />
                        <Clients />
                      </>
                    }
                  />
                  {/* <Route path="/gallery" element={<Gallery />} /> */}
                  <Route
                    path="/sales"
                    element={
                      <>
                        <Meta
                          title={metaInfo.sales.title}
                          description={metaInfo.sales.description}
                          keywords={metaInfo.sales.keywords}
                        />
                        <Sales />
                      </>
                    }
                  />
                  <Route
                    path="/review-management"
                    element={
                      <>
                        <Meta
                          title={metaInfo.reviewManagement.title}
                          description={metaInfo.reviewManagement.description}
                          keywords={metaInfo.reviewManagement.keywords}
                        />
                        <Review />
                      </>
                    }
                  />
                  <Route
                    path="/channel-manager"
                    element={
                      <>
                        <Meta
                          title={metaInfo.channelManager.title}
                          description={metaInfo.channelManager.description}
                          keywords={metaInfo.channelManager.keywords}
                        />
                        <Channel />
                      </>
                    }
                  />
                  <Route
                    path="/marketing"
                    element={
                      <>
                        <Meta
                          title={metaInfo.marketing.title}
                          description={metaInfo.marketing.description}
                          keywords={metaInfo.marketing.keywords}
                        />
                        <Marketing />
                      </>
                    }
                  />
                  <Route
                    path="/recruiting"
                    element={
                      <>
                        <Meta
                          title={metaInfo.recruiting.title}
                          description={metaInfo.recruiting.description}
                          keywords={metaInfo.recruiting.keywords}
                        />
                        <Hiring />
                      </>
                    }
                  />
                  {/* <Route path="/extension" element={
                  <>
                    <Meta title={metaInfo.extension.title} description={metaInfo.extension.description} keywords={metaInfo.extension.keywords} />
                    <Extension />
                  </>
                } /> */}
                  <Route
                    path="/lead-enrichment"
                    element={
                      <>
                        <Meta
                          title={metaInfo.dataEnrichment.title}
                          description={metaInfo.dataEnrichment.description}
                          keywords={metaInfo.dataEnrichment.keywords}
                        />
                        <DataEnrich />
                      </>
                    }
                  />
                  <Route
                    path="/data-to-lead"
                    element={
                      <>
                        <Meta
                          title={metaInfo.listBuilding.title}
                          description={metaInfo.listBuilding.description}
                          keywords={metaInfo.listBuilding.keywords}
                        />
                        <ListBuilding />
                      </>
                    }
                  />
                  <Route
                    path="/linkedin-extension"
                    element={
                      <>
                        <Meta
                          title={metaInfo.extension.title}
                          description={metaInfo.extension.description}
                          keywords={metaInfo.extension.keywords}
                        />
                        <Linkedin />
                      </>
                    }
                  />
                  <Route
                    path="/hospitality"
                    element={
                      <>
                        <Meta
                          title={metaInfo.hospitality.title}
                          description={metaInfo.hospitality.description}
                          keywords={metaInfo.hospitality.keywords}
                        />
                        <Hospitality />
                      </>
                    }
                  />
                  <Route
                    path="/data-outreach"
                    element={
                      <>
                        <Meta
                          title={metaInfo.keyFeatures.title}
                          description={metaInfo.keyFeatures.description}
                          keywords={metaInfo.keyFeatures.keywords}
                        />
                        <KeyFeatures />
                      </>
                    }
                  />
                  <Route
                    path="/finance"
                    element={
                      <>
                        <Meta
                          title={metaInfo.finance.title}
                          description={metaInfo.finance.description}
                          keywords={metaInfo.finance.keywords}
                        />
                        <Finance />
                      </>
                    }
                  />
                  <Route
                    path="/privacy-policy"
                    element={
                      <>
                        <Meta
                          title={metaInfo.privacyPolicy.title}
                          description={metaInfo.privacyPolicy.description}
                          keywords={metaInfo.privacyPolicy.keywords}
                        />
                        <Privacy />
                      </>
                    }
                  />
                  <Route
                    path="/security-policy"
                    element={
                      <>
                        <Meta
                          title={metaInfo.securityPolicy.title}
                          description={metaInfo.securityPolicy.description}
                          keywords={metaInfo.securityPolicy.keywords}
                        />
                        <SecurityPolicy />
                      </>
                    }
                  />
                  <Route
                    path="/terms-and-conditions"
                    element={
                      <>
                        <Meta
                          title={metaInfo.termsAndConditions.title}
                          description={metaInfo.termsAndConditions.description}
                          keywords={metaInfo.termsAndConditions.keywords}
                        />
                        <TermsAndConditions />
                      </>
                    }
                  />
                  <Route
                    path="/prospecting-search"
                    element={
                      <>
                        <Meta
                          title={metaInfo.prospectingSearch.title}
                          description={metaInfo.prospectingSearch.description}
                          keywords={metaInfo.prospectingSearch.keywords}
                        />
                        <ProspectingSearch />
                      </>
                    }
                  />
                  <Route
                    path="/technology"
                    element={
                      <>
                        <Meta
                          title={metaInfo.technology.title}
                          description={metaInfo.technology.description}
                          keywords={metaInfo.technology.keywords}
                        />
                        <Technology />
                      </>
                    }
                  />
                  <Route
                    path="/executive-details/:id"
                    element={
                      <AuthenticatedLayout>
                        <ExecutiveDetails />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route
                    path="/executive-details/:id/:name"
                    element={
                      <>
                        <Meta />
                        <AuthenticatedLayout>
                          <ExecutiveDetails />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  {/* <Route path='/product-comparison' element={<ProductComparison />} /> */}
                  <Route
                    path="/product-comparison"
                    element={
                      <>
                        <Meta
                          title={metaInfo.productComparison.title}
                          description={metaInfo.productComparison.description}
                          keywords={metaInfo.productComparison.keywords}
                        />
                        <ProductComparison />
                      </>
                    }
                  />
                  <Route
                    path="/search-company"
                    element={
                      <>
                        <Meta
                          title={metaInfo.searchCompany.title}
                          description={metaInfo.searchCompany.description}
                          keywords={metaInfo.searchCompany.keywords}
                        />
                        <ConditionalLayout>
                          <CompanySearch />
                        </ConditionalLayout>
                      </>
                    }
                  />
                  <Route
                    path="/search-executive"
                    element={
                      <>
                        <Meta
                          title={metaInfo.searchExecutive.title}
                          description={metaInfo.searchExecutive.description}
                          keywords={metaInfo.searchExecutive.keywords}
                        />
                        <ConditionalLayout>
                          <ExecutiveSearch />
                        </ConditionalLayout>
                      </>
                    }
                  />
                  <Route
                    path="/search-lead"
                    element={
                      <>
                        <Meta
                          title={metaInfo.searchLead.title}
                          description={metaInfo.searchLead.description}
                          keywords={metaInfo.searchLead.keywords}
                        />
                        <AuthenticatedLayout>
                          <LeadSearch />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  <Route
                    path="/company-summary/:id/:name"
                    element={
                      <ConditionalLayout>
                        <CompanySummary />
                      </ConditionalLayout>
                    }
                  />
                  <Route
                    path="/company-summary/:id"
                    element={
                      <ConditionalLayout>
                        <CompanySummary />
                      </ConditionalLayout>
                    }
                  />

                  <Route
                    path="/reputation-manager/settings"
                    element={
                      <AuthenticatedLayout>
                        <Settings />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route
                    path="/reputation-manager/reviews"
                    element={
                      <AuthenticatedLayout>
                        <Reviews />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route path="/checkout" element={<Checkout />} />
                  <Route
                    path="/my-account"
                    element={
                      <>
                        <Meta
                          title={metaInfo.myAccount.title}
                          description={metaInfo.myAccount.description}
                          keywords={metaInfo.myAccount.keywords}
                        />
                        <AuthenticatedLayout>
                          <MyAccount />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  <Route
                    path="/settings"
                    element={
                      <>
                        <Meta
                          title={metaInfo.settingsW2L.title}
                          description={metaInfo.settingsW2L.description}
                          keywords={metaInfo.settingsW2L.keywords}
                        />

                        <AuthenticatedLayout>
                          <SettingsPage />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  <Route
                    path="/settings/user-management"
                    element={
                      <>
                        <Meta
                          title={metaInfo.settingsW2L.title}
                          description={metaInfo.settingsW2L.description}
                          keywords={metaInfo.settingsW2L.keywords}
                        />

                        <AuthenticatedLayout>
                          <UserManagement />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  <Route
                    path="/settings/web-to-lead"
                    element={
                      <>
                        <Meta
                          title={metaInfo.settingsW2L.title}
                          description={metaInfo.settingsW2L.description}
                          keywords={metaInfo.settingsW2L.keywords}
                        />

                        <AuthenticatedLayout>
                          <Web2Lead />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  <Route
                    path="/settings/lead-custom-fields"
                    element={
                      <>
                        <Meta
                          title={metaInfo.settingsW2L.title}
                          description={metaInfo.settingsW2L.description}
                          keywords={metaInfo.settingsW2L.keywords}
                        />

                        <AuthenticatedLayout>
                          <LeadCustomFields />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  <Route
                    path="/settings/web-to-lead/create-form"
                    element={
                      <>
                        <Meta
                          title={metaInfo.settingsW2LCreateForm.title}
                          description={
                            metaInfo.settingsW2LCreateForm.description
                          }
                          keywords={metaInfo.settingsW2LCreateForm.keywords}
                        />

                        <AuthenticatedLayout>
                          <CreateLeadForm />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  <Route
                    path="/settings/web-to-lead/:id"
                    element={
                      <>
                        <Meta
                          title={metaInfo.settingsW2LCreateForm.title}
                          description={
                            metaInfo.settingsW2LCreateForm.description
                          }
                          keywords={metaInfo.settingsW2LCreateForm.keywords}
                        />
                        <AuthenticatedLayout>
                          <CreateLeadForm isEdit />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  <Route
                    path="/settings/email-setup"
                    element={
                      <>
                        <Meta
                          title={metaInfo.settingsEmailSetup.title}
                          description={metaInfo.settingsEmailSetup.description}
                          keywords={metaInfo.settingsEmailSetup.keywords}
                        />

                        <AuthenticatedLayout>
                          <EmailSetup />{" "}
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  <Route
                    path="/oauth2/google-authorize"
                    element={<AuthCallback type="gmail" />}
                  />
                  <Route
                    path="/oauth2/azure-authorize"
                    element={<AuthCallback type="outlook" />}
                  />
                  <Route
                    path="/oauth2/azure-signin-authorize"
                    element={<AuthCallback type="signin-outlook" />}
                  />
                  <Route
                    path="/oauth2/azure-signup-authorize"
                    element={<AuthCallback type="signup-outlook" />}
                  />
                  <Route
                    path="/oauth2/google-signin-authorize"
                    element={<AuthCallback type="signin-google" />}
                  />
                  <Route
                    path="/oauth2/google-signup-authorize"
                    element={<AuthCallback type="signup-google" />}
                  />
                  <Route
                    path="/oauth2/google-reputation-manager-authorize"
                    element={<AuthCallback type="reputation-manager-google" />}
                  />
                  <Route
                    path="/client-leads/gmail-import-authorize"
                    element={<AuthCallback type="gmail-import" />}
                  />
                  <Route
                    path="/client-leads/outlook-import-authorize"
                    element={<AuthCallback type="outlook-import" />}
                  />
                  <Route
                    path="/calendar/oauth-callback/google"
                    element={<AuthCallback type="google-calendar" />}
                  />
                  <Route
                    path="/calendar/oauth-callback/microsoft"
                    element={<AuthCallback type="outlook-calendar" />}
                  />

                  <Route
                    path="/our-data"
                    element={
                      <>
                        <Meta
                          title={metaInfo.ourData.title}
                          description={metaInfo.ourData.description}
                          keywords={metaInfo.ourData.keywords}
                        />
                        <OurData />
                      </>
                    }
                  />
                  {/* <Route path="/direct-dials" element={<DirectDials />} /> */}
                  <Route
                    path="/lead-management"
                    element={
                      <>
                        <Meta
                          title={metaInfo.ourData.title}
                          description={metaInfo.ourData.description}
                          keywords={metaInfo.ourData.keywords}
                        />
                        <LeadsManagement />
                      </>
                    }
                  />
                  <Route
                    path="/integrations"
                    element={
                      <>
                        <Meta
                          title={metaInfo.integrations.title}
                          description={metaInfo.integrations.description}
                          keywords={metaInfo.integrations.keywords}
                        />
                        <Integrations />
                      </>
                    }
                  />
                  <Route
                    path="/b2b-data"
                    element={
                      <>
                        <Meta
                          title={metaInfo.b2bData.title}
                          description={metaInfo.b2bData.description}
                          keywords={metaInfo.b2bData.keywords}
                        />
                        <B2BData />
                      </>
                    }
                  />
                  <Route
                    path="/faq"
                    element={
                      <>
                        <Meta
                          title={metaInfo.faq.title}
                          description={metaInfo.faq.description}
                          keywords={metaInfo.faq.keywords}
                        />
                        <Faq />
                      </>
                    }
                  />
                  <Route path="/leads" element={<Leads />} />
                  <Route
                    path="/lead-details/:id"
                    element={
                      <>
                        <Meta
                          title={metaInfo.searchLead.title}
                          description={metaInfo.searchLead.description}
                          keywords={metaInfo.searchLead.keywords}
                        />
                        <AuthenticatedLayout>
                          <LeadDetails />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  {/* <Route
                    path="/more-menu-content"
                    element={<MoreMenuContent />}
                  /> */}
                  <Route
                    path="/gen-ai-widget"
                    element={
                      <AuthenticatedLayout>
                        <GenAIWidget />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route
                    path="/whatsapp"
                    element={
                      <AuthenticatedLayout>
                        <WhatsApp view="inbox" />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route
                    path="/whatsapp-campaigns"
                    element={
                      <AuthenticatedLayout>
                        <WhatsApp view="campaigns" />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route
                    path="/whatsapp-campaigns/create"
                    element={
                      <AuthenticatedLayout>
                        <WhatsApp view="create-campaign" />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route
                    path="/whatsapp-campaigns/edit/:id"
                    element={
                      <AuthenticatedLayout>
                        <WhatsApp view="edit-campaign" />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route
                    path="/whatsapp-campaigns/:id/edit"
                    element={
                      <AuthenticatedLayout>
                        <WhatsApp view="edit-campaign" />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route
                    path="/campaigns/audience"
                    element={
                      <AuthenticatedLayout>
                        <WhatsAppAudience view="list" />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route
                    path="/campaigns/audience/create"
                    element={
                      <AuthenticatedLayout>
                        <WhatsAppAudience view="create" />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route
                    path="/campaigns/audience/:id"
                    element={
                      <AuthenticatedLayout>
                        <WhatsAppAudience view="details" />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route
                    path="/mail-merge"
                    element={
                      <AuthenticatedLayout>
                        <MailMergeListing />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route
                    path="/mail-merge/:id"
                    element={
                      <AuthenticatedLayout>
                        <MailMergeDetails />
                      </AuthenticatedLayout>
                    }
                  />
                  {/* Workspace Routes (Hidden / Disabled)
                  <Route
                    path="/my-workspace"
                    element={
                      <>
                        <Meta
                          title="Action Signals | BeyondLeadz"
                          description="Real-time buying intent and outreach signals across your campaigns"
                        />
                        <AuthenticatedLayout>
                          <MyWorkspace />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  <Route
                    path="/my-workspace/cohort/:cohortType"
                    element={
                      <>
                        <Meta
                          title="Cohort Leads | BeyondLeadz"
                          description="Detailed cohort leads and intent signals"
                        />
                        <AuthenticatedLayout>
                          <CohortLeadsPage />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  <Route
                    path="/workspace/cohort/:cohortType"
                    element={
                      <>
                        <Meta
                          title="Cohort Leads | BeyondLeadz"
                          description="Detailed cohort leads and intent signals"
                        />
                        <AuthenticatedLayout>
                          <CohortLeadsPage />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  <Route
                    path="/today"
                    element={
                      <>
                        <Meta
                          title="Today's Schedule | BeyondLeadz"
                          description="Today's schedule and activity feed"
                        />
                        <AuthenticatedLayout>
                          <TodayWorkspace />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  */}
                  <Route
                    path="/leads-timeline"
                    element={
                      <AuthenticatedLayout>
                        <LeadCalendar />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route
                    path="/leads-timeline/availability"
                    element={
                      <AuthenticatedLayout>
                        <AvailabilityFeature />
                      </AuthenticatedLayout>
                    }
                  />
                  <Route
                    path="/schedule-meeting/:customUrl"
                    element={
                      <MeetingPublicLayout>
                        <ScheduleMeeting />
                      </MeetingPublicLayout>
                    }
                  />
                  <Route
                    path="/reschedule-meeting/:id"
                    element={
                      <MeetingPublicLayout>
                        <ScheduleMeeting />
                      </MeetingPublicLayout>
                    }
                  />
                  <Route
                    path="/cancel-meeting/:id"
                    element={
                      <MeetingPublicLayout>
                        <CancelMeeting />
                      </MeetingPublicLayout>
                    }
                  />

                  <Route
                    path="/account/reset/finish"
                    element={<ResetPassword />}
                  />
                  <Route
                    path="/account/change-password"
                    element={<ChangePassword />}
                  />
                  {/* <Route path="/page/:slug" element={<Seo />} /> */}
                  <Route path="/best-hotels/:slug" element={<Seo />} />

                  <Route
                    path="/account/subscription-expired"
                    element={<SubscriptionExpired />}
                  />
                  <Route path="/page/:slug" element={<Seo />} />
                  <Route path="/tools/:demoUrl" element={<Demo />} />
                  {/* <Route path="/what-we-offer" element={<WhatWeOffer />} /> */}
                  <Route
                    path="/lead-import"
                    element={
                      <>
                        <Meta
                          title={metaInfo.dashboardView.title}
                          description={metaInfo.dashboardView.description}
                          keywords={metaInfo.dashboardView.keywords}
                        />
                        <AuthenticatedLayout>
                          <LeadImport />
                        </AuthenticatedLayout>
                      </>
                    }
                  />
                  <Route
                    path="*"
                    element={
                      <>
                        <center className="text-danger">Route NOT FOUND</center>
                      </>
                    }
                  />
                </Routes>
              </RouteGuard>
            </EmailProvider>
          </AuthProvider>
        </AlertProvider>
      </Router>
    </HelmetProvider>
  );
};
export default AppRoutes;
